const STORAGE_KEY = 'post-login-path';

const isAppPath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

export const rememberPostLoginPath = (path: string): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    return;
  }
};

export const forgetPostLoginPath = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};

export const takePostLoginPath = (): string | null => {
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    forgetPostLoginPath();
    return path && isAppPath(path) ? path : null;
  } catch {
    return null;
  }
};
